'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Lightbulb, ArrowRight, Leaf, Sparkles } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

export default function Slide02BigIdea({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0f2318]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1678077124691-807ee6f899fa"
          alt="Cảnh thiên nhiên rừng xanh bạt ngàn nhìn từ trên cao, hành trình khám phá thiên nhiên Việt Nam"
          className="w-full h-full object-cover opacity-10" />

        <div className="absolute inset-0 bg-gradient-to-bl from-[#0f2318] via-[#1a3a2a]/40 to-[#0f2318]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[rgba(76,175,125,0.04)] blur-3xl" />
        <svg className="absolute top-0 right-0 opacity-[0.04] w-[500px] h-[500px]" viewBox="0 0 200 200" fill="none">
          <path d="M100 10 C140 10 180 50 180 100 C180 140 140 180 100 180 C60 180 20 140 20 100 C20 50 60 10 100 10 Z" fill="#4caf7d" />
        </svg>
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-6">
          <div className="chapter-badge">
            <Lightbulb size={12} />
            Big Idea
          </div>
        </div>

        <div className="fade-in-up mb-4">
          <h2 className="font-display font-800 text-[clamp(32px,5vw,64px)] leading-[1.1] text-[#f0ede6] tracking-tight">Mỗi chuyến đi

          </h2>
          <h2 className="font-display font-800 text-[clamp(32px,5vw,64px)] leading-[1.1] tracking-tight">
            <span className="text-gradient-green">là 1 hành trình</span>
            <span className="text-[#a0b8a8]"> tuyệt vời</span>
          </h2>
        </div>

        <div className="fade-in-up mb-16">
          <div className="section-divider" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 fade-in-up">
          {[
          {
            icon: <Leaf size={24} className="text-[#4caf7d]" />,
            title: 'Trải nghiệm thật',
            desc: 'Là hành trình trải nghiệm – đóng góp – phát triển bản thân trong môi trường thiên nhiên thực sự',
            color: 'from-[rgba(76,175,125,0.12)] to-[rgba(76,175,125,0.04)]',
            border: 'border-[rgba(76,175,125,0.25)]'
          },
          {
            icon: <Sparkles size={24} className="text-[#e8a030]" />,
            title: 'Giá trị lâu dài',
            desc: 'Giá trị tạo ra vẫn tiếp tục sau khi chương trình kết thúc — không phải 1 lần rồi thôi',
            color: 'from-[rgba(232,160,48,0.12)] to-[rgba(232,160,48,0.04)]',
            border: 'border-[rgba(232,160,48,0.25)]'
          },
          {
            icon: <ArrowRight size={24} className="text-[#a8d87a]" />,
            title: 'Phát triển cá nhân',
            desc: 'Mỗi sinh viên rời đi với kỹ năng mới, nội dung thật, và câu chuyện riêng đáng tự hào',
            color: 'from-[rgba(168,216,122,0.12)] to-[rgba(168,216,122,0.04)]',
            border: 'border-[rgba(168,216,122,0.25)]'
          }].
          map((card) =>
          <div
            key={`bigidea-${card.title}`}
            className={`rounded-2xl p-8 bg-gradient-to-b ${card.color} border ${card.border} transition-all duration-300 hover:-translate-y-1`}>

              <div className="mb-5 p-3 rounded-xl bg-[rgba(255,255,255,0.05)] inline-flex">
                {card.icon}
              </div>
              <h3 className="font-display font-700 text-[20px] text-[#f0ede6] mb-3">{card.title}</h3>
              <p className="font-body text-[15px] text-[#a0b8a8] leading-relaxed">{card.desc}</p>
            </div>
          )}
        </div>

        <div className="fade-in-up mt-12 glass-card p-6 lg:p-8">
          <div className="flex items-start gap-4">
            <div className="w-1 flex-shrink-0 self-stretch rounded-full bg-gradient-to-b from-[#4caf7d] to-[#a8d87a]" />
            <p className="font-display text-[clamp(16px,2vw,22px)] font-600 text-[#f0ede6] leading-relaxed">
              "Không chỉ là chuyến đi —{' '}
              <span className="text-gradient-amber">mà là hành trình tạo giá trị"</span>
            </p>
          </div>
        </div>
      </div>
    </SlideWrapper>);

}